import { writable } from "svelte/store";

export const smartFilter = writable({ distributor: null });
